import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  createClassTitle: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem',
    margin: '0 0 0.5rem',
    fontWeight: '700',
    letterSpacing: '2%',
    textAlign: 'center',
  },
  createClassSubtitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[700],
    marginBottom: '1rem',
    marginTop: 0,
    textAlign: 'center',
    maxWidth: '60rem',
    margin: '0 auto',
  },
  eeGuideline: {
    margin: '0 auto',
    '& button:first-child': {
      fontSize: '1.6rem',
      margin: '0 auto',
    },
  },
  eeClassContentWrapper: {
    backgroundColor: colors.neutral.white,
    padding: '4rem',
    borderRadius: '1rem',
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    '& button:first-child': {
      marginRight: '2rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
